import React from 'react';
import SectionHeader from '@apricityhealth/web-common-lib/components/headers/SectionHeader';
import AddAlertIcon from '@material-ui/icons/AddAlert';

export default ({title, subtitle, color}) => {
    return (
        <SectionHeader
            color={color}
            title={title}
            subtitle={subtitle}
            icon={<AddAlertIcon style={{ color}}/>}
        />
    );
}

